import { fromJS, Map } from 'immutable';

export function request(state, action) {
    let auditDiff = state.get('auditDiff') || Map(),
        id = parseInt(action.id, 10);
    auditDiff = auditDiff.set(
        id,
        (auditDiff.get(id) || Map())
            .set('state', 'IN_PROGRESS')
    );
    return state.set('auditDiff', auditDiff);
}

export function error(state, action) {
    let auditDiff = state.get('auditDiff') || Map(),
        id = parseInt(action.id, 10);

    auditDiff = auditDiff.set(
        id,
        (auditDiff.get(id) || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(action.errors))
    );

    return state.set('auditDiff', auditDiff);
}

export function finish(state, action) {
    let auditDiff = state.get('auditDiff') || Map(),
        id = parseInt(action.id, 10);

    auditDiff = auditDiff.set(
        id,
        (auditDiff.get(id) || Map())
            .set('audit', fromJS(action.audit))
            .set('state', 'FINISHED')
    );
    return state.set('auditDiff', auditDiff);
}
